class Home {
	constructor() {
		const reveal = document.querySelector(".page-template-template-home .reveal-pane");

		if (reveal) {

		}

		const homeIntro = document.querySelector(".page-template-template-home .home-intro-title");

		if (homeIntro) {
			const lines = homeIntro.querySelectorAll('div');

			lines.forEach(line => {
				gsap.to(line, {
					scrollTrigger: {
						trigger: homeIntro,
						scrub: 1,
						start: "top 55%",
						end: "bottom top",
					},
					rotate: line.dataset.angle,
					force3D: true,
					duration: 1
				});
			});
		}

		const testimoniesSlider = document.querySelector(".page-template-template-home .swiper");

		if (testimoniesSlider) {
			const prevArrow = testimoniesSlider.querySelector('.swiper-button-prev');
			const nextArrow = testimoniesSlider.querySelector('.swiper-button-next');

			const slider = new Swiper(testimoniesSlider, {
				autoplay: {
					delay: 6500,
				},
				speed: 600,
				loop: true,
				loopPreventsSlide: false,
				allowTouchMove: true,
				effect: 'slide',
			});

			prevArrow.addEventListener("click", () => {
				slider.slidePrev();
			});
			nextArrow.addEventListener("click", () => {
				slider.slideNext();
			});
		}
	}
}